import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { X, Sparkles } from 'lucide-react';

const WelcomePopup = () => {
  const [show, setShow] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const seen = sessionStorage.getItem('welcome-seen');
    if (!seen) {
      const timer = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const close = () => {
    setShow(false);
    sessionStorage.setItem('welcome-seen', 'true');
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: 'hsl(215 75% 8% / 0.7)', backdropFilter: 'blur(8px)' }}
          onClick={close}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: 'spring', damping: 25 }}
            className="rounded-2xl p-8 max-w-lg w-full text-center relative overflow-hidden"
            style={{
              background: 'linear-gradient(160deg, hsl(215 65% 16%), hsl(215 75% 12%))',
              border: '1px solid hsl(40 85% 55% / 0.2)',
              boxShadow: '0 0 60px hsl(40 85% 55% / 0.1), 0 25px 50px hsl(215 75% 8% / 0.5)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button onClick={close} className="absolute top-4 end-4 transition-colors z-10" style={{ color: 'hsl(210 30% 60%)' }}>
              <X className="w-5 h-5" />
            </button>
            <div className="relative z-10">
              <motion.div
                animate={{ rotate: [0, 10, -10, 0] }}
                transition={{ repeat: Infinity, duration: 3 }}
                className="inline-block mb-4"
              >
                <Sparkles className="w-12 h-12" style={{ color: 'hsl(40 85% 60%)' }} />
              </motion.div>
              <h2 className="text-2xl font-bold mb-2 font-heading" style={{ color: 'hsl(45 100% 96%)' }}>
                {t('مرحباً بكم في أكاديمية الكفاح الأهلية للابتكار', 'Welcome to Al-Kifah Academy Innovation Hub')}
              </h2>
              <p className="text-lg font-semibold mb-1 gradient-text">
                {t('بإشراف أ/ منار سلمان العبدالمحسن', 'by Ms. Manar Salman Al-Abdulmohsen')}
              </p>
              <p className="text-sm mb-4" style={{ color: 'hsl(40 60% 60%)' }}>
                {t('معلمة التربية البدنية', 'Physical Education Teacher')}
              </p>
              <p className="leading-relaxed mb-6" style={{ color: 'hsl(210 30% 70%)' }}>
                {t(
                  'منصة مصممة لتمكين الطالبات والمعلمات وأولياء الأمور من الإبداع والتعاون والابتكار والنجاح.',
                  'A platform designed to empower students, teachers, and parents to create, collaborate, innovate, and succeed.'
                )}
              </p>
              <button
                onClick={close}
                className="px-8 py-3 rounded-xl font-semibold transition-all hover:scale-105 gold-glow"
                style={{
                  background: 'linear-gradient(135deg, hsl(40 85% 55%), hsl(35 80% 48%))',
                  color: 'hsl(215 75% 12%)'
                }}
              >
                {t('ابدأ الاستكشاف', 'Start Exploring')}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WelcomePopup;
